module.exports = __webpack_public_path__ + "pc/img/img12.d9faad6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/teachers/img12.png
// module id = Ss59
// module chunks = 3